import { Container, Row } from "reactstrap";
import RegistrationWithImageTwoContainer from "../../Componant/Authentication/RegistrationWithImageTwo";

const RegistrationWithImageTwo = () => {
  return (
    <Container fluid>
      <Row>
        <RegistrationWithImageTwoContainer />
      </Row>
    </Container>
  );
};

export default RegistrationWithImageTwo;
